<ion-row slot="bottom" class="ion-hide-md-up" fixed *ngIf="modelLocator.menu.bottom">

    <ion-col (click)="touchGoToRoute('/home')">
        <ion-img src="../../../assets/icon/menu/interacao-icon.png"></ion-img><br />
        <ion-label>INTERAÇÃO</ion-label>
    </ion-col>

    <ion-col (click)="touchGoToRoute('/activation-list')">
        <!-- <img class="tag_novo" src="../../assets/image/tag_novo.png" /> -->
        <ion-img src="../../../assets/icon/menu/ativacao-icon.png"></ion-img><br />
        <ion-label>ATIVAÇÕES</ion-label>
    </ion-col>

    <ion-col (click)="touchGoToRoute('/store')">
        <ion-img src="../../../assets/icon/menu/premiacao-icon.png"></ion-img><br />
        <ion-label>LOJA</ion-label>
    </ion-col>

    <ion-col (click)="touchGoToRoute('/challenges/list-of-challenges')">
        <ion-img src="../../../assets/icon/menu/superacao-icon.png"></ion-img><br />
        <ion-label>SUPERAÇÃO</ion-label>
    </ion-col>

    <ion-col (click)="touchGoToRoute('/help')" *ngIf="modelLocator.menu.suporte">
        <ion-img src="../../../assets/icon/menu/info-icon.png"></ion-img><br />
        <ion-label>SUPORTE</ion-label>
    </ion-col>

</ion-row>
